import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";
//import AuthDebug from "./components/AuthDebug";
import router from "./routes/chemin";

export default function App() {
  return (
    <AuthProvider>
      {/* <AuthDebug /> */}
      <ToastContainer position="top-right" autoClose={3000} />
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
